<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <div class="h2 mb-0">
            <b-icon-watch
              font-scale="3"
              animation="cylon"
            />
          </div>
          <h2 class="text-dark">
            Procesando ....
          </h2>
        </div>
      </template>

      <b-row>
        <b-col md="5">
          <contract-values :data="data" />
        </b-col>

        <b-col
          md="7"
          class="float-right"
        >
          <contract-balance
            :key="componentKey"
            :idcontrato="data.idcontrato"
            :resumen="true"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          md="12"
          class="float-right"
          align="right"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="secondary"
            @click="printAccountStatus(data.idcontrato)"
          >
            <feather-icon icon="PrinterIcon" />
            Imprimir Estado Cuenta
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="success"
            @click="searchAccountState()"
          >
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </b-col>
      </b-row>

      <b-form-group class="mt-1">
        <b-table
          :tbody-tr-class="rowClass"
          head-variant="dark"
          class="position-relative"
          :items="dataReport"
          responsive
          :fields="fieldscontratocuota"
          primary-key="idcontratocuota"
          show-empty
          empty-text="No matching records found"
          hover
        >
          <template #cell()="data">
            <span class="rowstyle">{{ data.value }}</span>
          </template>

          <template #cell(id)="dataRow">
            <span class="rowstyle">{{ dataRow.index + 1 }}</span>
          </template>

          <template #cell(fecha)="dataRow">
            <span class="rowstyle">{{
              dataRow.item.fecha | dateFormat
            }}</span>
          </template>
        </b-table>
      </b-form-group>
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormGroup,
  BIconWatch,
  BOverlay,
  BRow,
  BTable,
} from "bootstrap-vue"

import { avatarText } from "@core/utils/filter"
import Ripple from "vue-ripple-directive"
import ContractBalance from "./ContractBalance.vue"
import ContractValues from "./ContractValues.vue"

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BOverlay,
    BIconWatch,
    ContractValues,
    ContractBalance,
  },
  directives: {
    Ripple,
  },
  filters: {
    dateFormat (string) {
      return string.split("-").reverse().join("/")
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      show: true,
      fieldscontratocuota: [
        {
          key: "id",
          label: "No.",
          sortable: false,
          thStyle: "font-size: 10px;",
        },
        {
          key: "tipo",
          label: "Transaccion",
          sortable: false,
          thStyle: "font-size: 10px;",
        },
        {
          key: "fecha",
          label: "Fecha",
          sortable: false,
          thStyle: "font-size: 10px;",
        },
        {
          key: "detalle",
          label: "Concepto",
          sortable: false,
          thStyle: "font-size: 10px;",
        },
        {
          key: "debito",
          label: "Debito",
          sortable: false,
          thStyle: "font-size: 10px;",
          class: "text-right",
        },
        {
          key: "credito",
          label: "Credito",
          sortable: false,
          thStyle: "font-size: 10px;",
          class: "text-right",
        },
        {
          key: "saldo",
          label: "Saldo",
          sortable: false,
          thStyle: "font-size: 10px;",
          class: "text-right",
        },
      ],
      dataReport: [],
      componentKey: 0,
    }
  },
  created() {
    this.searchAccountState()
  },
  methods: {
    searchAccountState() {
      this.show = true
      this.$http
        .get("/contrato-estado-cuenta", {
          params: {
            idcontrato: this.data.idcontrato,
            idusuario: this.userData.id,
          },
        })
        .then((response) => {
          this.show = false
          this.dataReport = response.data.contratoscuota
        })
        .catch((error) => {
          this.show = false
          console.log(error)
        })
    },
    rowClass(item, type) {
      if (!item || type !== "row") {
        return
      }

      switch (item.tipo) {
      case "Cuota":
        return "table-success"
      case "Recibo Ingreso":
        return "table-primary"
      }
    },
    reload() {
      this.searchAccountState()
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1
    },
    printAccountStatus(id) {
      const routeUrl = this.$router.resolve({
        path: "/estado-cuenta-impresion",
        query: {
          idempresa: this.userData.idempresa,
          idsucursal: this.userData.idsucursal,
          idcontrato: id,
          opcion: 1,
        },
      })
      window.open(routeUrl.href, "_blank")
    },
  },
}
</script>

<style>
.rowstyle {
    font-size: 11px;
    color: black;
}
.rowstyleDet {
    font-size: 10px;
    color: black;
}
</style>
